export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11055.29862d28.jpg";